import type { ReactNode } from "react";
import { useFieldArray, useFormContext, type FieldArrayWithId, type UseFieldArrayReturn } from "react-hook-form";

type ListHelpers = UseFieldArrayReturn & {
    // Alias for `append` - reads better at call sites that just want to add a row.
    add: UseFieldArrayReturn["append"];
};

function List({ name, children }: {
    name: string,
    children: (fields: FieldArrayWithId[], helpers: ListHelpers) => ReactNode,
}) {
    const { control } = useFormContext();
    const fieldArray = useFieldArray({
        control,
        name
    });

    return (
        <>
            {children(fieldArray.fields, { ...fieldArray, add: fieldArray.append })}
        </>
    );
}

export default List;
